import { render, staticRenderFns } from "./Recorder.vue?vue&type=template&id=c82386d0"
import script from "./Recorder.vue?vue&type=script&lang=js"
export * from "./Recorder.vue?vue&type=script&lang=js"
import style0 from "./Recorder.vue?vue&type=style&index=0&id=c82386d0&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports